import { render, staticRenderFns } from "./SiteBlogsFeed.vue?vue&type=template&id=3f4d861c&"
import script from "./SiteBlogsFeed.vue?vue&type=script&lang=js&"
export * from "./SiteBlogsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports